import { Colors, Text } from '@helloself/hello-self-ui';
import React from 'react';

import { DashedBorderFlexBox } from './shared/DashedBorderFlexBox';

export type EmptyTilePlaceholderProps = {
    isOwnProfile?: boolean;
};

export function EmptyTilePlaceholder({ isOwnProfile }: EmptyTilePlaceholderProps) {
    let copy = "Partner/Expert hasn't updated this area yet";

    if (isOwnProfile) {
        copy = 'Update this area';
    }

    return (
        <DashedBorderFlexBox alignItems="center" justifyContent="center" padding="28px">
            <Text textColor={Colors.darkGrey} textSize="small" margin="0">
                {copy}
            </Text>
        </DashedBorderFlexBox>
    );
}
